function init() {
    const snapContainers = document.querySelectorAll('[data-scrollsnap-root]');
    if (snapContainers.length) {
        document.body.classList.add('scroll-snap-body');
    }
}

export default {
    init
};